<script>
	import { PWA } from '$lib/pwa.js';
	import { auth } from '$lib/auth.svelte.js';
</script>

<footer class="bg-navy text-parchment">
	<div class="h-px bg-gradient-to-r from-transparent via-gold to-transparent"></div>

	<div class="mx-auto max-w-6xl px-6 py-12">
		<!-- Cross ornament -->
		<p class="mb-6 text-center text-xl tracking-[0.5em] text-gold">☩</p>

		<div class="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
			<!-- Contact info -->
			<div>
				<h3 class="mb-3 text-lg font-semibold font-heading">St. Thomas Armenian Apostolic Church</h3>
				<address class="space-y-1 text-sm not-italic text-stone">
					<p>174 Essex Drive</p>
					<p>Tenafly, NJ 07670</p>
					<p class="mt-2">
						<a href="tel:+12015675446" class="transition-colors hover:text-gold">(201) 567-5446</a>
					</p>
				</address>
			</div>

			<!-- Quick links -->
			<div>
				<h3 class="mb-3 text-lg font-semibold font-heading">Quick Links</h3>
				<nav class="flex flex-col gap-2 text-sm text-stone">
					<a href="/" class="transition-colors hover:text-gold">Home</a>
					<a href="/about" class="transition-colors hover:text-gold">About</a>
					<a href="/events" class="transition-colors hover:text-gold">Events</a>
					<a href="/articles" class="transition-colors hover:text-gold">Articles</a>
					<a href="/contact" class="transition-colors hover:text-gold">Contact</a>
					{#if PWA.inviteInstall}
						<a href="/install" class="transition-colors hover:text-gold">Add App to Home Screen</a>
					{/if}
					<!-- Member portal. Invite-only, Parish Council first; relabel the signed-out label to
					     "Member Login" when sign-in opens to the general membership. -->
					{#if auth.member || auth.hint}
						<a href="/members" class="transition-colors hover:text-gold">Member Area</a>
					{:else}
						<a href="/login" class="transition-colors hover:text-gold">Parish Council Login</a>
					{/if}
				</nav>
			</div>

			<!-- Connect -->
			<div>
				<h3 class="mb-3 text-lg font-semibold font-heading">Connect</h3>
				<nav class="flex flex-col gap-2 text-sm text-stone">
					<a href="https://www.youtube.com/@saintthomasarmenianchurch8805/streams" target="_blank" rel="noopener noreferrer" class="transition-colors hover:text-gold">
						YouTube — Watch Live
					</a>
					<a href="http://facebook.com/Stthomasarmenianchurchnj" target="_blank" rel="noopener noreferrer" class="transition-colors hover:text-gold">
						Facebook
					</a>
					<a href="http://eepurl.com/bHErWz" target="_blank" rel="noopener noreferrer" class="transition-colors hover:text-gold">
						Subscribe to Bulletin
					</a>
					<a href="https://www.eservicepayments.com/cgi-bin/Vanco_ver3.vps?appver3=wWsk24ZWJSTZKsGd1RMKlg0BDvsSG3VIWQCPJNNxD8upkiY7JlDavDsozUE7KG0nFx2NSo8LdUKGuGuF396vbZYcLqyTMpcMsecVTK87yYMiYnTg5dP4O6rpX5QvPEWlBhHDN59kLZFffwKfYERpQmJ5pgq7LlE4NfFfD8N2g_Y%3D&ver=3" target="_blank" rel="noopener noreferrer" class="transition-colors hover:text-gold">
						Make a Donation
					</a>
				</nav>
			</div>
		</div>

		<!-- Copyright -->
		<div class="mt-10 border-t border-navy-light pt-6 text-center text-sm text-navy-muted">
			<p>&copy; 2023 - {new Date().getFullYear()} St. Thomas Armenian Apostolic Church</p>
		</div>
	</div>

	<!-- Extra bottom padding to clear the fixed bottom nav on mobile -->
	<div class="h-20 md:h-0"></div>
</footer>
